
import { Mapper } from "../../../../base/utils/mapper";
import { SpasmPhysiotherapyResponseModel } from "../../../../domain/models/consult/spasm-physiotherapy-response.model";
import { SpasmPhysiotherapyResponseEntity } from "../entities/spasm-physiotherapy-response.entity";

export class SpasmPhysiotherapyImplementationRepositoryMapper extends Mapper<SpasmPhysiotherapyResponseEntity, SpasmPhysiotherapyResponseModel>{
            mapFrom(param: SpasmPhysiotherapyResponseEntity):  SpasmPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param: SpasmPhysiotherapyResponseModel):  SpasmPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }